export const SUBMIT_AGAIN_REQUEST = 'SUBMIT_AGAIN_REQUEST'
export const SUBMIT_AGAIN_SUCCESS = 'SUBMIT_AGAIN_SUCCESS'
export const SUBMIT_AGAIN_FAIL = 'SUBMIT_AGAIN_FAIL'
export const SUBMIT_AGAIN_RESET = 'SUBMIT_AGAIN_RESET'